import BaseStore from '@/store/BaseStore'
import { Module, Mutation } from 'vuex-module-decorators'

export interface ModalOrderEditStoreInterface {
  collectionId: string
  bibliographyRealId: number
  onClickRegistration?: any
}

@Module({
  name: 'ModalOrderEditStore',
  namespaced: true,
  stateFactory: true
})
export default class ModalOrderEditStore extends BaseStore {
  _isOpen: boolean = false

  _collectionId: string = ''

  _bibliographyRealId: number = 0

  _registrationCallback?: any

  get isOpen(): boolean {
    return this._isOpen
  }

  get collectionId(): string {
    return this._collectionId
  }

  get bibliographyRealId(): number {
    return this._bibliographyRealId
  }

  @Mutation
  public open(params?: ModalOrderEditStoreInterface) {
    this._isOpen = true
    this._collectionId = params?.collectionId ?? ''
    this._bibliographyRealId = params?.bibliographyRealId ?? 0
    this._registrationCallback = params?.onClickRegistration
  }

  @Mutation
  public close(): void {
    this._isOpen = false
  }

  @Mutation
  public registration(): void {
    if (this._registrationCallback !== undefined) {
      this._registrationCallback()
    }

    this._isOpen = false
  }
}
